// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list_tableWrapper__nKJRV {
    background: var(--mui-palette-primary-200);
  }

.list_questionnaireActive__Mdt6P {
  background: var(--mui-palette-primary-200) !important;
  border: unset;
}

.list_questionnaireInactive__tPosk { 
  background: var(--mui-palette-error-200) !important;
  border: unset;
}

.list_MuiAccordionSummary-root__QrNpH::before {
  content: none !important;
}

.list_titleWrapper__ajnPx {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.list_paginationWrapper__3SvG3 {
  display: flex;
  justify-content: right;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/components/wttp/questionnnaires/list/index.module.css"],"names":[],"mappings":"AAAA;IACI,0CAA0C;EAC5C;;AAEF;EACE,qDAAqD;EACrD,aAAa;AACf;;AAEA;EACE,mDAAmD;EACnD,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB","sourcesContent":[".tableWrapper {\n    background: var(--mui-palette-primary-200);\n  }\n\n.questionnaireActive {\n  background: var(--mui-palette-primary-200) !important;\n  border: unset;\n}\n\n.questionnaireInactive { \n  background: var(--mui-palette-error-200) !important;\n  border: unset;\n}\n\n.MuiAccordionSummary-root::before {\n  content: none !important;\n}\n\n.titleWrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.paginationWrapper {\n  display: flex;\n  justify-content: right;\n  align-items: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableWrapper": `list_tableWrapper__nKJRV`,
	"questionnaireActive": `list_questionnaireActive__Mdt6P`,
	"questionnaireInactive": `list_questionnaireInactive__tPosk`,
	"MuiAccordionSummary-root": `list_MuiAccordionSummary-root__QrNpH`,
	"titleWrapper": `list_titleWrapper__ajnPx`,
	"paginationWrapper": `list_paginationWrapper__3SvG3`
};
export default ___CSS_LOADER_EXPORT___;
